import { render, staticRenderFns } from "./notification-predefined-templates-grid.vue?vue&type=template&id=d94d3764&scoped=true&"
import script from "./notification-predefined-templates-grid.ts?vue&type=script&lang=ts&"
export * from "./notification-predefined-templates-grid.ts?vue&type=script&lang=ts&"
import style0 from "./notification-predefined-templates-grid.scss?vue&type=style&index=0&id=d94d3764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94d3764",
  null
  
)

export default component.exports